import * as React from 'react';

export const IconCourseSocialTiktok = props => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.551 9.55v3.297a2.872 2.872 0 00-3.6 2.66 2.593 2.593 0 002.774 2.753 2.585 2.585 0 002.773-2.791V2.4h3.262c.554 3.452 2.28 4.253 4.592 4.622v3.308a9.833 9.833 0 01-4.5-1.52v6.534c0 2.96-1.752 6.256-6.102 6.256a6.13 6.13 0 01-6.102-6.287 6.012 6.012 0 016.903-5.763z"
      />
    </svg>
  );
};
